// import * as utils from '@/utils/utils';

import { Message } from 'antd'
import services from '../services/messageService.js'
const {
  getMessageList,
  getMessageTypes,
  getMessageUserList,
  getDraftCount,
  organizationList,
  messageOperat,
  getUserListbyIds,
  getMessageDetail,
  getOrgUserTree,
  messageEditOperat,
  feedbackList,
  handleReply,
  getFeedbackDetail,
  getSentCount,
} = services

const namespace = 'messageModel'

export default {
  namespace,
  state: {
    orgUserTreeList: [], // 分支和对应用户
    messageInfo: {}, // 消息详情
    selectUserList: [], // 选择机构下的会员列表
    organizationList: [], // 机构列表&分组列表
    messageTypeOptions: [], // 消息类型数组
    tableData: [], // 消息列表数据
    // 角色 设置弹窗
    setUpVisible: false,
    userData: [
      {
        key: '1',
        id: '003532',
        companyName: '北京城建',
        style: '理事',
        zizhi: '特级',
        xiehui: '秘书处',
        isFee: '是',
        date: '2020.03.01 15:00',
      },
      {
        key: '2',
        id: '003532',
        companyName: '北京城建',
        style: '理事',
        zizhi: '特级',
        xiehui: '秘书处',
        isFee: '是',
        date: '2020.03.01 15:00',
      },
    ],
    feedbackListData: [],
    // 答复详情
    feedbackDetail: {},
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // 获取消息列表
    *getMessageList({ payload, callback }, { call, put }) {
      const res = yield call(getMessageList, { ...payload })
      if (res && res.success) {
        // Message.success('加载成功');
        yield put({
          type: 'updateState',
          payload: {
            tableData: res.data.list,
          },
        })
        !!callback && callback(res)
      }
    },

    // 获取Filter参数: 消息类型
    *getMessageTypes({ payload, callback }, { call, put }) {
      const res = yield call(getMessageTypes, { ...payload })
      if (res && res.success) {
        // Message.success('加载成功');
        yield put({
          type: 'updateState',
          payload: {
            messageTypeOptions: res.data,
          },
        })
        !!callback && callback(res)
      }
    },

    // 获取Filter参数: 接收人
    *getMessageUserList({ payload, callback }, { call, put }) {
      const res = yield call(getMessageUserList, { ...payload })
      if (res && res.success) {
        // Message.success('加载成功');
        !!callback && callback(res)
      }
    },

    // 获取草稿数量
    *getDraftCount({ payload, callback }, { call, put }) {
      const res = yield call(getDraftCount, { ...payload })
      if (res && res.success) {
        // Message.success('加载成功');
        !!callback && callback(res)
      }
    },
    // 获取数量
    *getSentCount({ payload, callback }, { call, put }) {
      const res = yield call(getSentCount, { ...payload })
      if (res && res.success) {
        // Message.success('加载成功');
        !!callback && callback(res)
      }
    },

    // 新增
    *messageOperat({ payload, callback }, { call, put }) {
      const res = yield call(messageOperat, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      }
    },
    // 编辑
    *messageEditOperat({ payload, callback }, { call, put }) {
      const res = yield call(messageEditOperat, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      }
    },

    // 获取结构列表
    *getOrganizationList({ payload, callback }, { call, put }) {
      const res = yield call(organizationList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            organizationList: res.data,
          },
        })
      }
    },

    // 根据结构列表获取结构下的人员信息
    *getUserListbyIds({ payload, callback }, { call, put }) {
      const res = yield call(getUserListbyIds, payload)
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            selectUserList: res.data,
          },
        })
      }
    },

    *getMessageDetail({ payload, callback }, { call, put }) {
      // 发送请求之前先清空之前内存中的详情数据
      const res = yield call(getMessageDetail, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            messageInfo: res.data,
          },
        })
        !!callback && callback(res.data)
      }
    },
    *clearMessageInfoFromStore({ payload, callback }, { call, put }) {
      // 发送请求之前先清空之前内存中的详情数据
      yield put({
        type: 'updateState',
        payload: {
          messageInfo: [],
        },
      })
      !!callback && callback()
    },

    *getOrgUserTree({ payload, callback }, { call, put }) {
      const res = yield call(getOrgUserTree, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            orgUserTreeList: res.data,
          },
        })
        !!callback && callback(res.data)
      }
    },

    // 消息答复列表
    *feedbackList({ payload, callback }, { call, put }) {
      const res = yield call(feedbackList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            feedbackListData: res.data.list,
          },
        })
        !!callback && callback(res.data)
      }
    },

    // 协会答复
    *handleReply({ payload, callback }, { call, put }) {
      const res = yield call(handleReply, { ...payload })
      if (res && res.success) {
        !!callback && callback(res.data)
        Message.success(res.msg)
      } else {
        Message.error(res.msg)
      }
    },

    // 协会答复消息查看
    *getFeedbackDetail({ payload, callback }, { call, put }) {
      const res = yield call(getFeedbackDetail, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            feedbackDetail: res.data,
          },
        })
        !!callback && callback(res.data)
      } else {
        Message.error(res.msg)
      }
    },
  },

  // 订阅事件
  subscriptions: {},
}
